import dayjs from "dayjs";
import React,{ useEffect, useState } from "react";
import { Form } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify";
import { getSignedAttachmentUrl } from "../../../api/attachApi";
import { getAllClinicVisitByUser } from "../../../api/clinicVisitApi";
import { getOU } from "../../../api/ouApi";
import { getDepartment } from "../../../api/deptApi";
import { getESSEmployee } from "../../../api/employeeApi";
import { getClinicCode } from "../../../api/clinicApi";
import ClinicVisitAdminForm from "../../forms/AdminPortal/ClinicVisitAdminForm";
import { useLocation } from "react-router-dom";

export default function ClinicVisitAdminPage({ history}) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [allClinicVisitDS, setAllClinicVisitDS] = useState([]);
  const [filteredClinicVisitDS, setFilteredClinicVisitDS] = useState([]);
  const [form] = Form.useForm();
  const location = useLocation();   //remain filter values when close input form
  const [currentYear, setCurrentYear] = useState(
    location.state ? location.state.filterYear : dayjs().year()
  );
  const [currentMonth, setCurrentMonth] = useState(
    location.state ? location.state.filterMonth : dayjs().month() + 1
  );
  const [allClinicCodes, setAllClinicCodes] = useState([]);
  const [allOUs, setAllOUs] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [initialUsers, setInitialUsers] = useState([]);
  const [clinicKey, setClinicKey] = useState(
    location.state ? location.state.filterClinicKey : 0
  );
  const [ouKey, setOUKey] = useState(
    location.state ? location.state.filterOUKey : 0
  );
  const [deptKey, setDeptKey] = useState(
    location.state ? location.state.filterDeptKey : 0
  );
  const [userKey, setUserKey] = useState(
    location.state ? location.state.filterUserKey : 0
  );
  const [pagination, setPagination] = useState(
    {
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });

  useEffect(getClinicVisits, []);

  function getClinicVisits() {
    let promises = [
      getClinicVisitDataSource(currentYear, currentMonth),
      getClinicCode(),
      getOU(),
      getDepartment(),
      getESSEmployee(),
    ];

    Promise.all(promises).then((values) => {
      resetPagination();

      setAllClinicCodes(values[1] ? values[1] : []);
      setAllOUs(values[2] ? values[2].filter((x) => x.Active) : []);
      setAllDepartments(values[3] ? values[3].filter((x) => x.Active) : []);
      setAllUsers(values[4] ? values[4] : []);
      setInitialUsers(values[4] ? values[4] : []);
      setIsLoading(false);
    })
    .catch((error) => {
      setIsLoading(false);
      setAllClinicVisitDS([]);
      setFilteredClinicVisitDS([]);
      setAllClinicCodes([]);
      setAllOUs([]);
      setAllDepartments([]);
      setAllUsers([]);
      setInitialUsers([]);
      showErrorMessage(
        t('general.fail_to_load_record') + 
          error.response.data.error_description
      );
    });
  }

  function getClinicVisitDataSource(currentYear, currentMonth) {
    setIsLoading(true);
    
    getAllClinicVisitByUser(currentYear, currentMonth, true)
      .then((result) => {
        setAllClinicVisitDS(result);
        setFilteredClinicVisitDS(
          result.filter(
            (x) => 
              (ouKey === 0 || x.OUKey === ouKey) &&
              (deptKey === 0 || x.DeptKey === deptKey) &&
              (userKey === 0 || x.UserKey === userKey) && 
              (clinicKey === 0 || x.ClinicKey === clinicKey)
            )
        );

        setIsLoading(false);
      }).catch((error) => {
        setIsLoading(false);
        setAllClinicVisitDS([]);
        setFilteredClinicVisitDS([]);
        showErrorMessage(
          t('general.fail_to_load_record') + 
            error.response.data.error_description
        );
      });
  }

  function onViewClinicVisit(clinicTransKey) {
    history("/home/clinicvisit/clinictrans/" + clinicTransKey, 
    { state: { 
      fromAdmin: true,
      filterOUKey: ouKey,
      filterDeptKey: deptKey,
      filterUserKey: userKey,
      filterClinicKey: clinicKey,
      filterYear: currentYear,
      filterMonth: currentMonth,
    }});
  }

  function getValidAttachments(attachments) {
    return getSignedAttachmentUrl(attachments);
  }

  function filterRecord(ouKey, deptKey, userKey, clinicKey) {
    setOUKey(ouKey);
    setDeptKey(deptKey);
    setUserKey(userKey);
    setClinicKey(clinicKey);
    setFilteredClinicVisitDS(
      allClinicVisitDS.filter(
        (x) => 
          (ouKey === 0 || x.OUKey === ouKey) &&
          (deptKey === 0 || x.DeptKey === deptKey) &&
          (userKey === 0 || x.UserKey === userKey) && 
          (clinicKey === 0 || x.ClinicKey === clinicKey)
        )
    );
  }

  function showErrorMessage(message) {
    toast.error(message);
  }

  function resetPagination() {
    setPagination({
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });
  }

  return (
    <ClinicVisitAdminForm 
      isLoading={isLoading}
      clinicVisitDS={filteredClinicVisitDS}
      getClinicVisitDataSource={getClinicVisitDataSource}
      form={form}
      onViewClinicVisit={onViewClinicVisit}
      onAttachmentClicked={getValidAttachments}
      setCurrentYear={setCurrentYear}
      setCurrentMonth={setCurrentMonth}
      allClinicCodes={allClinicCodes}
      allOUs={allOUs}
      allDepartments={allDepartments}
      allUsers={allUsers}
      initialUsers={initialUsers}
      setAllUsers={setAllUsers}
      ouKey={ouKey}
      deptKey={deptKey}
      userKey={userKey}
      clinicKey={clinicKey}
      currentYear={currentYear}
      currentMonth={currentMonth}
      filterRecord={filterRecord}
      pagination={pagination}
      setPagination={setPagination}
      resetPagination={resetPagination}
    />
  );
}

ClinicVisitAdminPage.propTypes = {
  history: PropTypes.func.isRequired,
};